import { useAuth0 } from '@auth0/auth0-vue';
import { toRaw } from 'vue';

/** ログインしているユーザーが属するアカウントのIDを返す */
const getAccountId = () => {
  const auth0 = toRaw(useAuth0()?.user.value);
  return auth0?.organization.id;
};

/** ログインしているユーザーが属するアカウントの名前を返す */
const getAccountName = () => {
  const auth0User = toRaw(useAuth0()?.user);
  if (auth0User?.value) {
    return auth0User.value.organization.name;
  } else {
    return '';
  }
};

/** ログインしているユーザーのユーザー名を返す */
const getUserName = () => {
  const auth0User = toRaw(useAuth0()?.user);
  if (auth0User?.value) {
    return auth0User.value.nickname;
  } else {
    return '';
  }
};

/**ログインしているユーザーのユーザーIDを返す */
const getUserId = () => {
  const auth0 = toRaw(useAuth0()?.user.value);
  return auth0?.sub;
};

const getUserRole = () => {
  const auth0User = toRaw(useAuth0().user?.value?.['user/roles']);
  if (auth0User && auth0User.includes('role-administrator')) {
    return 'role-administrator';
  } else {
    return 'role-viewer';
  }
};

export const getOrganizationRoleDetails = () => {
  const roleDetails = toRaw(useAuth0()?.user?.value?.['organization/roles']);
  return roleDetails ? roleDetails : [];
};

export const getLicenseAndAuthorityList = () => {
  const licenseList: any[] = [];
  const authorityList: any[] = [];

  const roleDetails = getOrganizationRoleDetails();
  for (const role of roleDetails) {
    if (role.name.startsWith('license')) {
      const parsed = JSON.parse(role.description);
      const serviceId = parsed.serviceId;
      if (!licenseList.includes(serviceId)) licenseList.push(serviceId);
    } else if (role.name.startsWith('authority')) {
      const id = role.name.replace(/^authority-/, ''); // removes "authority-" only from the beginning
      authorityList.push(id);
    }
  }
  return { licenseList, authorityList };
};

export default {
  getAccountId,
  getAccountName,
  getUserName,
  getUserId,
  getUserRole,
  getOrganizationRoleDetails,
  getLicenseAndAuthorityList,
};
